<script setup>
import Thumbnail from 'dashboard/components/widgets/Thumbnail.vue';
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store.js';

const props = defineProps({
  user: {
    type: Object,
    default: () => {},
  },
  size: {
    type: String,
    default: '20px',
  },
  textClass: {
    type: String,
    default: 'text-xs text-slate-600',
  },
});

const currentAccountId = useMapGetter('getCurrentAccountId');

const contactProfileLink = computed(() => {
  return `/app/accounts/${currentAccountId.value}/contacts/${props.user.id}`;
});
</script>

<template>
  <div class="flex items-center gap-1.5 text-left">
    <Thumbnail
      :src="user.thumbnail"
      :size="size"
      :username="user.name"
      :status="user.availability_status"
    />
    <h6
      class="my-0 dark:text-slate-100 overflow-hidden whitespace-nowrap text-ellipsis text-capitalize"
      :class="textClass"
    >
      {{ user.name }}
    </h6>
    <a
      v-if="user.id"
      :href="contactProfileLink"
      class="text-base"
      target="_blank"
      rel="noopener nofollow noreferrer"
    >
      <woot-button
        size="tiny"
        icon="open"
        variant="clear"
        color-scheme="secondary"
      />
    </a>
  </div>
</template>
